<template>
  <v-container grid-list-xl fluid>
    <v-layout>
      <v-flex>
        <v-card>
          <v-card-title>
            <search-field ref="searchRef" @search="search"></search-field>
            <v-spacer></v-spacer>
            <v-btn fab dark small color="amber darken-2" @click="getData">
              <v-icon dark>play_arrow</v-icon>
            </v-btn>
            <v-tooltip top>
              <v-btn
                fab
                dark
                small
                color="amber darken-2"
                slot="activator"
                @click="refreshData()"
              >
                <v-icon>refresh</v-icon>
              </v-btn>
              <span>Refresh</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn
                fab
                dark
                small
                color="amber darken-2"
                slot="activator"
                @click="downloadExcel()"
              >
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path
                    fill="#ffffff"
                    d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z"
                  />
                </svg>
              </v-btn>
              <span>Download Excel</span>
            </v-tooltip>
          </v-card-title>

          <v-container grid-list-lg fluid style="padding: 20px;" class="mt-3">
            <v-layout>
              <v-flex md2 style="padding: 0 5px;">
                <v-menu
                  ref="dateFromMenu"
                  :close-on-content-click="false"
                  v-model="dateFromMenu"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dateFrom"
                    label="Date From"
                    prepend-inner-icon="event"
                    outline
                    readonly
                  ></v-text-field>

                  <v-date-picker
                    ref="picker"
                    v-model="dateFrom"
                    :max="dateTo"
                    min="1950-01-01"
                    @input="dateFromMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex md2 style="padding: 0 5px;">
                <v-menu
                  ref="timeFromMenu"
                  :close-on-content-click="false"
                  v-model="timeFromMenu"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="timeFrom"
                    @click="clockMode = 'timeFrom'"
                    label="Time From"
                    prepend-inner-icon="event"
                    outline
                    readonly
                  ></v-text-field>

                  <v-time-picker v-model="timeFrom" format="24hr">
                    <v-btn flat color="amber" @click="cancelTimePicker"
                      >Cancel</v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-btn flat color="amber" @click="timeFromMenu = false"
                      >DONE</v-btn
                    >
                  </v-time-picker>
                </v-menu>
              </v-flex>

              <v-flex md2 style="padding: 0 5px;">
                <v-menu
                  ref="dateToMenu"
                  :close-on-content-click="false"
                  v-model="dateToMenu"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dateTo"
                    label="Date To"
                    prepend-inner-icon="event"
                    outline
                    readonly
                  ></v-text-field>

                  <v-date-picker
                    ref="picker"
                    v-model="dateTo"
                    :max="new Date().toISOString().substr(0, 10)"
                    :min="dateFrom"
                    @input="dateToMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex md2 style="padding: 0 5px;">
                <v-menu
                  ref="timeToMenu"
                  :close-on-content-click="false"
                  v-model="timeToMenu"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="timeTo"
                    @click="clockMode = 'timeTo'"
                    label="Time To"
                    prepend-inner-icon="event"
                    outline
                    readonly
                  ></v-text-field>
                  <v-time-picker v-model="timeTo" format="24hr">
                    <v-btn flat color="amber" @click="cancelTimePicker"
                      >Cancel</v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-btn flat color="amber" @click="timeToMenu = false"
                      >DONE</v-btn
                    >
                  </v-time-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-container>

          <v-snackbar v-model="snackbar" left top :timeout="15000">
            <span v-if="copied === true">
              Copied
              {{ number }} to Clipboard!
            </span>
            <span v-else>
              Copy&nbsp;
              <input
                type="text"
                :value="number"
                id="contactNumber"
                color="white"
                :size="number.length > 11 ? 9 + number.length / 3 : 9"
              />
              to Clipboard
            </span>
            <v-btn flat @click="snackbar = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-snackbar>

          <v-divider></v-divider>

          <v-container fluid class="pa-2">
            <v-layout row>
              <v-flex sm4 md4></v-flex>
              <v-flex sm8 md8>
                <v-container class="py-2 pr-0" fluid>
                  <v-layout row align-center>
                    <v-flex xs12 sm8 md9 class="py-0">
                      <v-layout row align-center>
                        <v-flex xs6 sm10 md11 class="px-0">
                          <p
                            class="text-xs-right grey--text caption"
                            style="font-size: 14px; margin-top: 14px;"
                          >
                            Row per Page:
                          </p>
                        </v-flex>
                        <v-flex xs6 sm2 md1 class="text-xs-center">
                          <v-layout row align-center>
                            <v-flex xs7 sm12>
                              <v-select
                                style="font-size: 14px;"
                                :items="page"
                                class="grey--text"
                                id="selected"
                                v-model="pageLimit"
                                @input="limitClick"
                                dense
                                height="20px"
                                :disabled="
                                  this.items.length < 10 ? true : false
                                "
                              ></v-select>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm4 md3 class="py-0">
                      <v-layout row align-center>
                        <v-flex xs6 sm6 class="px-0 pl-3">
                          <p
                            class="text-xs-center grey--text caption"
                            style="font-size: 14px; margin-top: 14px;"
                          >
                            {{ itemFrom + " -" + itemTo + " of " }}
                            {{ totalItems }}
                          </p>
                        </v-flex>
                        <v-flex xs6 sm6>
                          <v-layout row style="padding-right: 100px;">
                            <v-flex sm6 class="mr-3 pl-0">
                              <v-btn
                                fab
                                light
                                small
                                flat
                                @click="backClick"
                                :disabled="disabledBack"
                              >
                                <v-icon dark>chevron_left</v-icon>
                              </v-btn>
                            </v-flex>
                            <v-flex sm6>
                              <v-btn
                                fab
                                light
                                small
                                flat
                                @click="nextClick"
                                :disabled="disabledNext"
                              >
                                <v-icon dark>chevron_right</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>

          <v-divider></v-divider>

          <v-data-table
            :headers="headers"
            :items="items"
            hide-actions
            disable-initial-sort
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-center">
                {{ props.index + queryParams.offset + 1 }}
              </td>
              <td class="text-xs-center text-uppercase">
                <v-btn
                  icon
                  slot="activator"
                  @mouseover="changeNumber(props.item.contact_no)"
                  @click="copyToClipboard()"
                  small
                >
                  <v-icon color="green">file_copy</v-icon>
                </v-btn>
              </td>
              <td class="text-xs-left text-uppercase">
                {{ props.item.contact_no }}
              </td>
              <td class="text-xs-left text-uppercase">
                {{ props.item.card_no }}
              </td>
              <td class="text-xs-center text-uppercase">
                {{ $dateFormat(props.item.updated_at, "YYYY-MM-DD") }}
              </td>
              <td class="text-xs-center text-uppercase">
                {{ $dateFormat(props.item.updated_at, "HH:mm") }}
              </td>
            </template>
          </v-data-table>
          <v-divider></v-divider>
          <v-container class="py-0" fluid>
            <v-layout wrap align-center class="pa-5"></v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Services from "@/services/Services";
import XLSX from "xlsx";
var now = new Date();

export default {
  data() {
    return {
      copied: false,
      snackbar: false,
      number: "",
      dateFromMenu: false,
      dateToMenu: false,
      timeFromMenu: false,
      timeToMenu: false,
      timeFrom: "00:00",
      timeTo: "23:59",

      title: "Contact Number",
      headers: [
        { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        {
          text: "",
          align: "center",
          sortable: false,
        },
        {
          text: "Contact No.",
          align: "left",
          value: "contact_no",
          sortable: false,
        },
        {
          text: "Card No.",
          align: "left",
          value: "card_no",
          sortable: false,
        },
        {
          text: "Date",
          align: "center",
          value: "updated_at",
          sortable: false,
        },
        {
          text: "Time",
          align: "center",
          value: "updated_at",
          sortable: false,
        },
      ],
      items: [],
      uploadHeaders: [
        { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: true,
        },
      ],
      queryParams: {
        search: "",
        limit: 10,
        offset: 0,
      },
      uploadItems: [],
      dialogType: "",
      dialogStatus: false,
      openConfirmDialog: false,
      viewData: {},
      deleteDialog: false,
      confirmLoading: false,
      dialogLoading: false,
      uploadDialog: false,
      fileinput: "",
      disableSaveUpload: true,

      totalItems: 0,
      itemFrom: 0,
      itemTo: 0,
      disabledNext: false,
      disabledBack: true,
      disabledLimit: true,
      limit: 10,
      offset: 0,
      page: [
        { text: 10, value: 10 },
        { text: 20, value: 20 },
        { text: 30, value: 30 },
        { text: 40, value: 40 },
        { text: 50, value: 50 },
        { text: 60, value: 60 },
        { text: 70, value: 70 },
        { text: 80, value: 80 },
        { text: 90, value: 90 },
        { text: 100, value: 100 },
      ],
      dateFrom: this.$dateFormat(now, "YYYY-MM-DD"),
      dateTo: this.$dateFormat(now, "YYYY-MM-DD"),
    };
  },
  created: function() {
    this.getData();
  },
  computed: {
    pageLimit: {
      get() {
        return 10;
      },
      set(val) {
        this.queryParams.limit = val;
        this.queryParams.offset = 0;
      },
    },
  },
  watch: {
    limit: function() {
      this.queryParams.limit = this.limit;
      this.queryParams.offset = 0;
      this.getData();
    },
  },
  methods: {
    search(data) {
      this.queryParams.search = data;
      this.queryParams.offset = 0;
      this.queryParams.limit = 10;
      this.getData();
    },
    async getData() {
      // Start Loading
      this.items = [];

      this.queryParams.date_from = this.dateFrom + " " + this.timeFrom + ":00";
      this.queryParams.date_to = this.dateTo + " " + this.timeTo + ":59";
      this.queryParams.type = this.filterType;

      this.$store.dispatch("startLoading");
      try {
        // Query Data
        let response = (await Services.getContactNumber(this.queryParams)).data;

        // Assign the reponse data to items to be display on table
        this.items = response.data;

        // Assign Total number of data
        this.totalItems = response.count;

        // Assign Number started the data
        this.itemFrom = this.totalItems > 0 ? this.queryParams.offset + 1 : 0;

        // Assign Number end the data
        this.itemTo = this.queryParams.offset + this.queryParams.limit;

        if (this.totalItems <= this.itemTo) {
          this.itemTo = this.totalItems;
        }

        // Conditions for NextPage Button
        if (this.itemTo === this.totalItems) {
          this.disabledNext = true;
        } else {
          this.disabledNext = false;
        }
        // Conditions for BackPage Button
        if (this.itemFrom > 1) {
          this.disabledBack = false;
        } else {
          this.disabledBack = true;
        }

        if (this.totalItems <= this.queryParams.limit) {
          this.disabledLimit = true;
        } else {
          this.disabledLimit = false;
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network connection",
          });
        }
      }
      this.$store.dispatch("endLoading");
    },

    nextClick() {
      this.queryParams.offset += this.queryParams.limit;
      this.getData();
    },
    backClick() {
      this.queryParams.offset -= this.queryParams.limit;
      this.getData();
    },
    async limitClick() {
      this.queryParams.offset = 0;
      this.getData();
    },
    itemNumber(data) {
      return data + this.queryParams.offset + 1;
    },
    refreshData() {
      this.$refs.searchRef.clear();
      this.dateFrom = this.$dateFormat(now, "YYYY-MM-DD");
      this.dateTo = this.$dateFormat(now, "YYYY-MM-DD");
      this.getData();
    },
    changeNumber(data) {
      this.copied = false;
      this.number = data;
      this.snackbar = true;
    },
    copyToClipboard() {
      this.copied = true;

      var copyText = document.getElementById("contactNumber");

      copyText.select();

      document.execCommand("copy");
    },
    async downloadExcel() {
      let dataToDownload = [];
      let header = [];

      for (let i = 1; i < this.headers.length; i++) {
        header.push(this.headers[i].text.toUpperCase());
      }

      header.shift();

      dataToDownload.push(header);

      for (let e = 0; e < this.items.length; e++) {
        let theItem = [];

        theItem.push(this.items[e].contact_no);
        theItem.push(this.items[e].card_no);
        theItem.push(this.$dateFormat(this.items[e].updated_at, "YYYY-MM-DD"));
        theItem.push(this.$dateFormat(this.items[e].updated_at, "HH:mm"));

        dataToDownload.push(theItem);
      }

      // don't delete any codes after this comment got it?!

      var wscols = [
        { wch: 30 }, // "pixels"
        { wch: 30 }, // "pixels"
        { wch: 20 }, // "pixels"
        { wch: 20 }, // "pixels"
        { wch: 20 }, // "pixels"
        { wch: 30 }, // "pixels"
        { wch: 40 }, // "pixels"
        { wch: 20 }, // "pixels"
        { wch: 20 }, // "pixels"
        { wch: 20 }, // "pixels"
        { wch: 20 }, // "pixels"
      ];

      var wsrows = [];

      var ws = XLSX.utils.aoa_to_sheet(dataToDownload, { cellDates: true });
      var wb = XLSX.utils.book_new();
      // var wsname = "SheetJS";

      var fmt = "#,##0";

      var range = XLSX.utils.decode_range(ws["!ref"]);
      for (var e = range.s.r + 1; e <= range.e.r; ++e) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var ref = XLSX.utils.encode_cell({ r: e, c: C });
          if (!ws[ref]) continue;
          if (ws[ref].t !== "n") continue;
          ws[ref].z = fmt;
        }
      }

      XLSX.utils.book_append_sheet(wb, ws);

      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;

      wb.Props = {
        Title: this.title,
        Subject: this.title,
        Author: "Developer of Journeytech",
        Company: "Journeytech",
        Category: "Reports",
      };

      if (!wb.Workbook) wb.Workbook = { Sheets: [], WBProps: {} };
      if (!wb.Workbook.WBProps) wb.Workbook.WBProps = {};
      wb.Workbook.WBProps.filterPrivacy = true;

      var filenames = [
        [this.title + ".xlsx"],
        [this.title + ".xlsm"],
        [this.title + ".xlsb"],
        [this.title + ".xlam"],
        [this.title + ".biff8.xls", { bookType: "xls" }],
        [this.title + ".biff5.xls", { bookType: "biff5" }],
        [this.title + ".biff2.xls", { bookType: "biff2" }],
        [this.title + ".xml.xls", { bookType: "xlml" }],
        [this.title + ".xla"],
        [this.title + ".ods"],
        [this.title + ".fods"],
        [this.title + ".csv"],
        [this.title + ".txt"],
        [this.title + ".slk"],
        [this.title + ".eth"],
        [this.title + ".htm"],
        [this.title + ".dif"],
        [this.title + ".dbf", { sheet: "Hidden" }],
        [this.title + ".rtf"],
        [this.title + ".prn"],
      ];
      var OUT = ["base64", "binary", "string", "array"];
      if (typeof Buffer !== "undefined") OUT.push("buffer");
      filenames.forEach(function(r) {
        XLSX.writeFile(wb, r[0], r[1]);
        if (typeof process !== "undefined") XLSX.readFile(r[0]);

        var ext = (r[1] && r[1].bookType) || r[0].split(".")[1];
        ext = { htm: "html" }[ext] || ext;
        OUT.forEach(function(type) {
          if (
            type === "string" &&
            [
              "xlsx",
              "xlsm",
              "xlsb",
              "xlam",
              "biff8",
              "biff5",
              "biff2",
              "xla",
              "ods",
              "dbf",
            ].indexOf(ext) > -1
          )
            return;
          if (
            type === "array" &&
            ["xlsx", "xlsm", "xlsb", "xlam", "ods"].indexOf(ext) > -1 &&
            typeof Uint8Array === "undefined"
          )
            return;
          var datout = XLSX.write(wb, {
            type: type,
            bookType: ext,
            sheet: (r[1] && r[1].sheet) || null,
          });
          XLSX.read(datout, { type: type });
          if (type === "array") console.log(ext, datout);
        });
      });
    },
    cancelTimePicker() {
      if (this.clockMode === "timeFrom") {
        this.timeFrom = "00:00";
        this.timeFromMenu = false;
      }
      if (this.clockMode === "timeTo") {
        this.timeTo = "23:59";
        this.timeToMenu = false;
      }
    },
  },
};
</script>

<style></style>
